module.exports = __webpack_public_path__ + "static/media/arrow_scroll_next.fb3df7a5.svg";